import * as uuid from 'uuid';
var uuidv4 = uuid.v4;
var SoundManager = /** @class */ (function () {
    function SoundManager() {
        this._soundIdStateListeners = {};
    }
    SoundManager.getInstance = function () {
        if (SoundManager.instance) {
            return SoundManager.instance;
        }
        SoundManager.instance = new SoundManager();
        return SoundManager.getInstance();
    };
    SoundManager.prototype.getMostRecentSound = function (sound) {
        if (SoundManager.cache[sound.id]) {
            if (new Date(sound.updated_at) <= new Date(SoundManager.cache[sound.id].updated_at)) {
                return SoundManager.cache[sound.id];
            }
        }
        return sound;
    };
    SoundManager.prototype.updateSound = function (sound) {
        SoundManager.cache[sound.id] = sound;
        this.callSoundStateListeners(sound);
    };
    SoundManager.prototype.setSoundsInPackageDownloaded = function (sound_package_id) {
        var sounds = Object.keys(SoundManager.cache).filter(function (s) { return SoundManager.cache[s].sound_package_id == sound_package_id; });
        this.setSoundsDownloaded(sounds);
    };
    SoundManager.prototype.setSoundsDownloaded = function (sound_ids) {
        var _this = this;
        var sounds = sound_ids.map(function (s) {
            return SoundManager.cache[s];
        }).filter(Boolean);
        sounds.forEach(function (sound) {
            sound.downloaded = true;
            SoundManager.cache[sound.id] = sound;
            _this.callSoundStateListeners(sound);
        });
    };
    SoundManager.prototype.setStreamDuration = function (id, streamedDuration) {
        var sound = SoundManager.cache[id];
        if (sound) {
            sound.streamed = streamedDuration;
            SoundManager.cache[sound.id] = sound;
            this.callSoundStateListeners(sound);
        }
    };
    SoundManager.prototype.addSoundStateListener = function (sound, listener) {
        var id = uuidv4();
        var listenersObj = {};
        listenersObj[id] = listener;
        this._soundIdStateListeners[sound.id] = Object.assign({}, (this._soundIdStateListeners[sound.id] || {}), listenersObj);
        if (SoundManager.cache[sound.id]) {
            if (new Date(sound.updated_at) < new Date(SoundManager.cache[sound.id].updated_at)) {
                listener(SoundManager.cache[sound.id]);
            }
            else {
                SoundManager.cache[sound.id] = sound;
            }
        }
        else {
            SoundManager.cache[sound.id] = sound;
        }
        return id;
    };
    SoundManager.prototype.removeSoundStateListener = function (sound, id) {
        this._soundIdStateListeners[sound.id] && delete this._soundIdStateListeners[sound.id][id];
    };
    SoundManager.prototype.callSoundStateListeners = function (sound) {
        var _this = this;
        Object.keys(this._soundIdStateListeners[sound.id] || {}).map(function (key) { return (_this._soundIdStateListeners[sound.id] || {})[key]; }).forEach(function (data) {
            var cb = data;
            cb(sound);
        });
    };
    SoundManager.cache = {};
    return SoundManager;
}());
export default SoundManager;
//# sourceMappingURL=soundmanager.js.map